import { render, staticRenderFns } from "./IconBadgeCoin.vue?vue&type=template&id=4cd88a76"
import script from "./IconBadgeCoin.vue?vue&type=script&lang=js"
export * from "./IconBadgeCoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports